import AES from 'crypto-js/aes';
import Utf8 from 'crypto-js/enc-utf8';
const encryptionKey = "red!!encr!!yption123!!..Trusted??.bizTun";


//todo: add Error Handling cause is the first entry point
export const encryptToken = (token) => {
  return AES.encrypt(token, encryptionKey).toString();
};

export const decryptToken = (encryptedToken) => {
    try {
        const decryptedToken = AES.decrypt(encryptedToken, encryptionKey).toString(Utf8);
        return decryptedToken;
    } catch (error) {
        console.error("Error decrypting token", error);
        return null;
    }
};

